import { ApolloLink } from '@apollo/client';
import { uploadAccessToken } from '@frameio/utils/auth';
import { X_UPLOAD_ACCESS_TOKEN_HEADER } from '@frameio/utils/auth/constants';

/**
 * Adds the verified uploader's access token as `X-Upload-Access-Token` on every
 * upload-session request once the visitor has passed OTP verification. The token
 * lives in a session cookie shared across upload link ids and tabs, so this link
 * reads it fresh per operation and simply forwards unchanged when absent (the
 * attempt-first flow then surfaces UNAUTHENTICATED and opens the OTP popover).
 *
 * Added only for the anonymous upload-link session (see `all.ts`).
 */
export const uploadAccessTokenLink = new ApolloLink((operation, forward) => {
  const token = uploadAccessToken.getAccessToken();

  if (token) {
    operation.setContext({
      headers: {
        ...operation.getContext()?.headers,
        [X_UPLOAD_ACCESS_TOKEN_HEADER]: token,
      },
    });
  }

  return forward(operation);
});
